class MapFilterListController {
  constructor() {
    this.selected = null;
  }
  
  moved(index){
    console.log(index);
  }
}

export default MapFilterListController;
